import { useTranslation } from 'react-i18next';
import { Screen } from '../../shell/Screen';
import { EmptyState } from '../../components/EmptyState';
import { RequireProfile } from '../../shell/RequireProfile';

export function BookingsPage() {
  const { t } = useTranslation('shell');
  return (
    <Screen title={t('tabs.bookings')}>
      <RequireProfile profiles={['client']}>
        <EmptyState icon="calendarCheck" title={t('bookings.emptyTitle')}>{t('bookings.emptyBody')}</EmptyState>
      </RequireProfile>
    </Screen>
  );
}
